/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { connect } from "react-redux";
import dayjs from "dayjs";
import getDecodeDescription from "../../services/decodeText";
import { getOneNewsLink } from "../../services/linkGenerator";
import Button from "../Button/Button";
import styles from "./Article.module.scss";

const Article = ({
  ///ADD SAVE/EDIT BUTTON
  article = {},
  fullSize = true,
  isFirst = false,
  onSave,
  blog,
  isResearcher,
  role,
}) => {
  const [image, setImage] = useState(null);
  const [isCopySuccess, setIsCopySuccess] = useState("");

  useEffect(() => {
    setImage(article.photo);
  }, [article]);

  const getDateHhml = () => (
    <p className={styles.date}>
      {dayjs(article?.date).format("MMMM DD, YYYY")}
    </p>
  );
  const getDateHhmlFull = () => (
    <p className={styles.dateFullScreen}>
      {dayjs(article?.date).format("MMMM DD, YYYY")}
    </p>
  );
  const decodedString = getDecodeDescription(`<div>${article?.body}</div>`);

  const shareArticle = () => {
    const url = getOneNewsLink(article.title, article.key);
    navigator.clipboard.writeText(url);
    setIsCopySuccess(true);
    setTimeout(() => {
      setIsCopySuccess(false);
    }, 500);
  };

  return (
    <div
      className={cx(styles.mainArticleFullScreen, {
        [styles.mainArticleContainer]: isFirst,
      })}
    >
      {fullSize ? (
        <div className={cx({ [styles.imageContainerFullScreen]: fullSize })}>
          <div className={styles.infoSpotContainer}>
            <div
              className={cx(
                { [styles.firstArticleImage]: isFirst },
                { [styles.image]: !isFirst },
                { [styles.backgroundBig]: fullSize },
                { [styles.imageFullScreen]: fullSize }
              )}
              style={{ backgroundImage: `url(${image ? image : null})` }}
            ></div>
            {article?.photoSource && (
              <span className="news-figcaption">
                (Credit:{article?.photoSource})
              </span>
            )}
            {fullSize && <span className={styles.field}>{article?.field}</span>}

            {fullSize && (
              <h1
                className={cx(
                  styles.containerText,
                  styles.titleUrl,
                  styles.titleFullSize,
                  {
                    [styles.titleSmall]: !fullSize,
                  }
                )}
              >
                {article?.title}
              </h1>
            )}

            {!fullSize && (
              <span
                className={cx(styles.titleUrl, styles.title, {
                  [styles.titleSmall]: !fullSize,
                })}
              >
                {article?.title}
              </span>
            )}

            {fullSize && getDateHhmlFull()}
            <pre
              className={cx(
                { [styles.containerText]: fullSize },
                styles.newsBody,
                {
                  [styles.newsBodySmall]: !fullSize,
                }
              )}
              dangerouslySetInnerHTML={{ __html: decodedString }}
            ></pre>
            {!fullSize && getDateHhml()}
            {fullSize && !blog && (
              <div className={styles.source}>
                <a
                  className={styles.link}
                  target="_blank"
                  rel="nofollow"
                  href={article?.source}
                >
                  View the article source
                </a>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className={cx(
            { [styles.firstArticleImage]: isFirst },
            { [styles.image]: !isFirst },
            { [styles.backgroundBig]: fullSize }
          )}
          style={{
            backgroundImage: `url(${
              image
                ? image
                : "https://img.freepik.com/free-photo/beautiful-shot-crystal-clear-lake-snowy-mountain-base-during-sunny-day_181624-5459.jpg?size=626&ext=jpg&ga=GA1.2.810972297.1659950584"
            })`,
          }}
        ></div>
      )}
      <div
        className={cx(
          { [styles.newsAllTextContainer]: fullSize },
          { [styles.firstNewsAllTextContainer]: isFirst }
        )}
      ></div>
      {!isResearcher && (
        <>
          <Button
            className={cx(styles.getLinkButton, styles.button)}
            onClick={() => shareArticle()}
          >
            Get original URL
          </Button>
          {isCopySuccess && (
            <p className={styles.linkSuccess}>Link successfully copied</p>
          )}
          <Button
            disabled={article.status !== "pending_review"}
            className={cx(styles.saveButton, styles.button)}
            onClick={() => {
              delete article._id;
              onSave({ article, userRole: role, type: "news" });
            }}
          >
            Save
          </Button>
        </>
      )}
      {!isResearcher && article.status !== "pending_review" && (
        <div className="mt-5"></div>
      )}
    </div>
  );
};

Article.propTypes = {
  article: PropTypes.object,
  fullSize: PropTypes.bool,
  isFirst: PropTypes.bool,
};

const mapStateToProps = ({ user: { role } }) => {
  return {
    role,
  };
};

export default connect(mapStateToProps, null)(Article);
